import { __rest } from "tslib";
import React from 'react';
import clsx from 'clsx';
import { makeStyles, Tooltip as MuiTooltip } from '@material-ui/core';
import { tokens } from '@getgo/chameleon-core';
const useStyles = makeStyles(() => ({
    tooltip: {
        backgroundColor: tokens.neutral,
        color: 'var(--goto-text-04)',
        // @ts-ignore
        [`& .${window.CLASSNAME_PREFIX}-MuiTooltip-arrow`]: {
            color: tokens.neutral,
        },
    },
    informationTooltip: {
        cursor: 'help',
    },
}));
export const Tooltip = (_a) => {
    var { noDelay, placement = 'top', children, isInfo, className } = _a, otherProps = __rest(_a, ["noDelay", "placement", "children", "isInfo", "className"]);
    // Hooks
    const classes = useStyles();
    return (React.createElement(MuiTooltip, Object.assign({ arrow: true, enterDelay: noDelay ? 0 : 500, placement: placement, className: clsx(isInfo && classes.informationTooltip, className), classes: {
            tooltip: classes.tooltip,
        } }, otherProps), children));
};
